const themes = {
    "modern-minimal": {
        font: "'Inter', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#ffffff",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#1a1a1a",
        questionsLabelFont: "'Inter', sans-serif",
        questionsLabelFontSize: { lg: "24px", sm: "20px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Inter', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#4a4a4a",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#2563eb",
        buttonsBorderRadius: 6,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#ef4444",
        errorsBgColor: "#fee2e2",
        progressBarFillColor: "#2563eb",
        progressBarBgColor: "#e5e7eb",
        formFooterBgColor: { lg: "#f8fafc", sm: "#f8fafc" }
    },

    // 2. Corporate Trust
    "corporate-trust": {
        font: "'Source Sans Pro', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#f8fafc",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#1e293b",
        questionsLabelFont: "'Source Sans Pro', sans-serif",
        questionsLabelFontSize: { lg: "26px", sm: "22px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Source Sans Pro', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#475569",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "lg",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "14px", sm: "12px" },
            bottom: { lg: "14px", sm: "12px" },
            left: { lg: "28px", sm: "24px" },
            right: { lg: "28px", sm: "24px" }
        },
        buttonsBgColor: "#0f172a",
        buttonsBorderRadius: 8,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#dc2626",
        errorsBgColor: "#fef2f2",
        progressBarFillColor: "#0f172a",
        progressBarBgColor: "#e2e8f0",
        formFooterBgColor: { lg: "#f1f5f9", sm: "#f1f5f9" }
    },

    // 3. Elegant Serif
    "elegant-serif": {
        font: "'Merriweather', serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.7", sm: "1.6" },
        backgroundColor: "#fffaf3",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#292524",
        questionsLabelFont: "'Merriweather', serif",
        questionsLabelFontSize: { lg: "28px", sm: "24px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Merriweather', serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.7", sm: "1.6" },
        answersColor: "#44403c",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "18px", sm: "14px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "lg",
        answersMargin: { lg: "22px", sm: "18px" },
        buttonsPadding: {
            top: { lg: "16px", sm: "14px" },
            bottom: { lg: "16px", sm: "14px" },
            left: { lg: "32px", sm: "28px" },
            right: { lg: "32px", sm: "28px" }
        },
        buttonsBgColor: "#854d0e",
        buttonsBorderRadius: 4,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#b91c1c",
        errorsBgColor: "#fef2f2",
        progressBarFillColor: "#854d0e",
        progressBarBgColor: "#f5f5f4",
        formFooterBgColor: { lg: "#fef3c7", sm: "#fef3c7" }
    },

    // 4. Tech Modern
    "tech-modern": {
        font: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.5", sm: "1.4" },
        backgroundColor: "#18181b",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#ffffff",
        questionsLabelFont: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
        questionsLabelFontSize: { lg: "28px", sm: "24px" },
        questionsLabelLineHeight: { lg: "1.3", sm: "1.2" },
        questionsDescriptionFont: "'SF Pro Display', -apple-system, BlinkMacSystemFont, sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.5", sm: "1.4" },
        answersColor: "#d4d4d8",
        buttonsFontColor: "#18181b",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#22d3ee",
        buttonsBorderRadius: 8,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#f87171",
        errorsBgColor: "#450a0a",
        progressBarFillColor: "#22d3ee",
        progressBarBgColor: "#3f3f46",
        formFooterBgColor: { lg: "#27272a", sm: "#27272a" }
    },

    // 5. Nature Fresh
    "nature-fresh": {
        font: "'Nunito', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#f0fdf4",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#166534",
        questionsLabelFont: "'Nunito', sans-serif",
        questionsLabelFontSize: { lg: "26px", sm: "22px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Nunito', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#166534",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#16a34a",
        buttonsBorderRadius: 25,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#dc2626",
        errorsBgColor: "#fee2e2",
        progressBarFillColor: "#16a34a",
        progressBarBgColor: "#dcfce7",
        formFooterBgColor: { lg: "#dcfce7", sm: "#dcfce7" }
    },

    // 6. Creative Studio
    "creative-studio": {
        font: "'Poppins', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#fdf4ff",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#581c87",
        questionsLabelFont: "'Poppins', sans-serif",
        questionsLabelFontSize: { lg: "28px", sm: "24px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Poppins', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#6b21a8",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "14px", sm: "12px" },
            bottom: { lg: "14px", sm: "12px" },
            left: { lg: "28px", sm: "24px" },
            right: { lg: "28px", sm: "24px" }
        },
        buttonsBgColor: "#9333ea",
        buttonsBorderRadius: 12,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#e11d48",
        errorsBgColor: "#ffe4e6",
        progressBarFillColor: "#9333ea",
        progressBarBgColor: "#f3e8ff",
        formFooterBgColor: { lg: "#f3e8ff", sm: "#f3e8ff" }
    },

    // 7. Professional Dark
    "professional-dark": {
        font: "'IBM Plex Sans', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#0f172a",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#e2e8f0",
        questionsLabelFont: "'IBM Plex Sans', sans-serif",
        questionsLabelFontSize: { lg: "26px", sm: "22px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'IBM Plex Sans', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#cbd5e1",
        buttonsFontColor: "#0f172a",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#e2e8f0",
        buttonsBorderRadius: 6,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#f87171",
        errorsBgColor: "#451a1a",
        progressBarFillColor: "#e2e8f0",
        progressBarBgColor: "#1e293b",
        formFooterBgColor: { lg: "#1e293b", sm: "#1e293b" }
    },

    // 8. Boutique Luxury
    "boutique-luxury": {
        font: "'Playfair Display', serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.7", sm: "1.6" },
        backgroundColor: "#fafaf9",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#292524",
        questionsLabelFont: "'Playfair Display', serif",
        questionsLabelFontSize: { lg: "32px", sm: "28px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Lato', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#44403c",
        buttonsFontColor: "#fafaf9",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "18px", sm: "14px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "lg",
        answersMargin: { lg: "22px", sm: "18px" },
        buttonsPadding: {
            top: { lg: "16px", sm: "14px" },
            bottom: { lg: "16px", sm: "14px" },
            left: { lg: "32px", sm: "28px" },
            right: { lg: "32px", sm: "28px" }
        },
        buttonsBgColor: "#78716c",
        buttonsBorderRadius: 0,
        buttonsBorderWidth: 1,
        buttonsBorderColor: "#57534e",
        errorsFontColor: "#991b1b",
        errorsBgColor: "#fef2f2",
        progressBarFillColor: "#78716c",
        progressBarBgColor: "#e7e5e4",
        formFooterBgColor: { lg: "#f5f5f4", sm: "#f5f5f4" }
    },

    // 9. Ocean Breeze
    "ocean-breeze": {
        font: "'Montserrat', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#ecfeff",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#164e63",
        questionsLabelFont: "'Montserrat', sans-serif",
        questionsLabelFontSize: { lg: "26px", sm: "22px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Montserrat', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#155e75",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#0891b2",
        buttonsBorderRadius: 30,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#dc2626",
        errorsBgColor: "#fee2e2",
        progressBarFillColor: "#0891b2",
        progressBarBgColor: "#cffafe",
        formFooterBgColor: { lg: "#cffafe", sm: "#cffafe" }
    },

    // 10. Startup Fresh
    "startup-fresh": {
        font: "'DM Sans', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#ffffff",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#111827",
        questionsLabelFont: "'DM Sans', sans-serif",
        questionsLabelFontSize: { lg: "28px", sm: "24px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'DM Sans', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#374151",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "14px", sm: "12px" },
            bottom: { lg: "14px", sm: "12px" },
            left: { lg: "28px", sm: "24px" },
            right: { lg: "28px", sm: "24px" }
        },
        buttonsBgColor: "#4f46e5",
        buttonsBorderRadius: 8,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#dc2626",
        errorsBgColor: "#fee2e2",
        progressBarFillColor: "#4f46e5",
        progressBarBgColor: "#e0e7ff",
        formFooterBgColor: { lg: "#f9fafb", sm: "#f9fafb" }
    },

    // 11. Nordic Simplicity
    "nordic-simplicity": {
        font: "'Work Sans', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#f8fafc",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#334155",
        questionsLabelFont: "'Work Sans', sans-serif",
        questionsLabelFontSize: { lg: "26px", sm: "22px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Work Sans', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#475569",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#64748b",
        buttonsBorderRadius: 4,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#dc2626",
        errorsBgColor: "#fee2e2",
        progressBarFillColor: "#64748b",
        progressBarBgColor: "#e2e8f0",
        formFooterBgColor: { lg: "#f1f5f9", sm: "#f1f5f9" }
    },

    // 12. Wellness Zen
    "wellness-zen": {
        font: "'Open Sans', sans-serif",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#f0fdfa",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#134e4a",
        questionsLabelFont: "'Open Sans', sans-serif",
        questionsLabelFontSize: { lg: "26px", sm: "22px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Open Sans', sans-serif",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#115e59",
        buttonsFontColor: "#ffffff",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "14px", sm: "12px" },
            bottom: { lg: "14px", sm: "12px" },
            left: { lg: "28px", sm: "24px" },
            right: { lg: "28px", sm: "24px" }
        },
        buttonsBgColor: "#0f766e",
        buttonsBorderRadius: 20,
        buttonsBorderWidth: 0,
        buttonsBorderColor: "transparent",
        errorsFontColor: "#dc2626",
        errorsBgColor: "#fee2e2",
        progressBarFillColor: "#0f766e",
        progressBarBgColor: "#ccfbf1",
        formFooterBgColor: { lg: "#ccfbf1", sm: "#ccfbf1" }
    },

    // 13. Urban Edge
    "urban-edge": {
        font: "'Roboto Mono', monospace",
        fontSize: { lg: "18px", sm: "16px" },
        fontLineHeight: { lg: "1.6", sm: "1.5" },
        backgroundColor: "#18181b",
        backgroundImage: "",
        backgroundImageFocalPoint: { x: 0.5, y: 0.5 },
        logo: { type: "", src: "" },
        questionsColor: "#fafafa",
        questionsLabelFont: "'Roboto Mono', monospace",
        questionsLabelFontSize: { lg: "24px", sm: "20px" },
        questionsLabelLineHeight: { lg: "1.4", sm: "1.3" },
        questionsDescriptionFont: "'Roboto Mono', monospace",
        questionsDescriptionFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionLineHeight: { lg: "1.6", sm: "1.5" },
        answersColor: "#e4e4e7",
        buttonsFontColor: "#18181b",
        buttonsFontSize: { lg: "16px", sm: "14px" },
        questionsDescriptionMargin: { lg: "16px", sm: "12px" },
        textInputAnswers: { lg: "16px", sm: "14px" },
        typographyPreset: "md",
        answersMargin: { lg: "20px", sm: "16px" },
        buttonsPadding: {
            top: { lg: "12px", sm: "10px" },
            bottom: { lg: "12px", sm: "10px" },
            left: { lg: "24px", sm: "20px" },
            right: { lg: "24px", sm: "20px" }
        },
        buttonsBgColor: "#a1a1aa",
        buttonsBorderRadius: 0,
        buttonsBorderWidth: 2,
        buttonsBorderColor: "#71717a",
        errorsFontColor: "#f87171",
        errorsBgColor: "#451a1a",
        progressBarFillColor: "#a1a1aa",
        progressBarBgColor: "#27272a",
        formFooterBgColor: { lg: "#27272a", sm: "#27272a" }
    }
}